import { DateRange } from '../../constants/ui';

export const MINUTE_IN_MS = 60 * 1000;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;

export const DAILY_AGGREGATION_RANGES: DateRange[] = ['7days', '30days', '60days', '90days', '120days', '150days', '180days', '360days'];

export const isDailyAggregationRange = (range: DateRange) => DAILY_AGGREGATION_RANGES.includes(range);

// Stable constant objects for Recharts props (prevents unnecessary re-renders from new object references)
export const TICK_STYLE = { fontSize: 12 } as const;
export const TOOLTIP_WRAPPER_STYLE = { zIndex: 1000 } as const;
export const CHART_CONTENT_STYLE = { backgroundColor: '#1e293b', border: '1px solid #334155' } as const;

// Chart colors for model distribution
export const CHART_COLORS = [
  '#82ca9d', '#ffc658', '#ff7300', '#0088fe', '#8884d8',
  '#808080', '#9370db', '#ff69b4', '#20b2aa', '#d53e4f',
  '#66c2a5', '#fc8d59', '#8da0cb', '#e78ac3', '#a6d854'
] as const;

// Moving average window size for cost trend
export const MOVING_AVERAGE_WINDOW_SIZE = 14;

// Offset in ms used to duplicate single data points so Recharts renders a visible line
export const SINGLE_POINT_OFFSET = 3600000;
